// extracted by mini-css-extract-plugin
export default {"list":"RowList-module--list--01a4f"};